import Debug from '../Atoms/Debug';

const DebugPlugin = {
  install(Vue, options = {}) {
    Vue.component('CmradDebug', Debug);
  },
};

export default DebugPlugin;
